import { render } from "./popupContent.vue?vue&type=template&id=512e5dab&scoped=true"
import script from "./popupContent.vue?vue&type=script&lang=js"
export * from "./popupContent.vue?vue&type=script&lang=js"

import "./popupContent.vue?vue&type=style&index=0&id=512e5dab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512e5dab"]])

export default __exports__